<input
  type="number"
  class="gonvarri-product-quote-discount"
  (focusout)="editEntry()"
  [(ngModel)]="quotePromotionNewPrice"
  [disabled]="disableDiscountInput"
/>
